
import Vue from 'vue';
import { Avatar, buildAvatar } from './avatar-builder';
import { checkIfImageLoads } from '@/widgets/assets';
import Icon, { Icon as IconName } from '@/common/icon/Icon.vue';

export default Vue.extend({
    name: 'Avatar',

    components: {
        Icon
    },

    props: {
        userId: {
            type: String,
            default: ''
        },
        userName: {
            type: String,
            default: ''
        },
        questionId: {
            type: String,
            default: ''
        },
        profilePicture: {
            type: String,
            default: ''
        },
        showUserInitials: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            profilePic: '',
            icon: IconName.silhouette
        };
    },

    computed: {
        avatar(): Avatar {
            return buildAvatar(
                this.userId,
                this.userName,
                this.questionId
            );
        },
        color(): string {
            return this.avatar.color;
        },
        initials(): string {
            return this.avatar.initials;
        }
    },

    watch: {
        profilePicture: {
            immediate: true,
            handler() {
                this.setProfilePic();
            }
        },
    },

    methods: {
        async setProfilePic() {
            this.profilePic = (this.profilePicture && await checkIfImageLoads(this.profilePicture)) ? this.profilePicture : '';
        }
    }
});
